import React from 'react';

const Title = ({ title }) => {
  return (
    <h3 className="text-center">
      { title }
    </h3>
  )
}
export default Title;